<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <option-menu class="no-bg no-border">
          <div class="content-title-wrap">
            <div class="main-content-title">Document</div>
            <div class="main-content-menu">
              <div class="searchbox">
                <label for="roleFilter">
                  <i
                    v-if="!filterTxt"
                    class="material-icons-outlined align-middle"
                    >search</i
                  >
                  <i
                    v-else
                    @click="onQuickFilterChanged"
                    class="material-icons-outlined align-middle"
                    >clear</i
                  >
                </label>
                <input
                  id="roleFilter"
                  type="text"
                  @keyup="onQuickFilterChanged"
                  :value="filterTxt"
                  placeholder="Search"
                />
              </div>
              <button
                class="btn primary"
                href="javascript:void(0);"
                @click="addLink()"
                :class="{ active: editOpen == 2 }"
                title="Add Project"
              >
                <i class="material-icons-outlined align-middle">add</i>
                Add Link
              </button>
              <button
                class="btn primary"
                href="javascript:void(0);"
                @click="addFile()"
                :class="{ active: editOpen == 2 }"
                title="Add Project"
              >
                <i class="material-icons-outlined align-middle">add</i>
                Add File
              </button>
            </div>
          </div>
        </option-menu>
        <div class="main-bg p-0">
          <ag-grid-vue
            style="width: 100%; height: calc(100vh - 230px)"
            class="ag-theme-material"
            :gridOptions="gridOptions"
            :columnDefs="columnDefs"
            @column-resized="onColumnResized"
            @first-data-rendered="onFirstDataRendered"
            @grid-size-changed="onFirstDataRendered"
            :rowData="rowData"
          ></ag-grid-vue>
        </div>
      </div>
      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" title>
          <PanelDocument
            v-if="editOpen == 1"
            :submitLoading="submitLoading"
            @buttonClick="panelButtonClick"
          ></PanelDocument>
          <PanelLink
            v-if="editOpen == 2"
            :submitLoading="linkSubmitLoading"
            @buttonClick="panelLinkButtonClick"
          ></PanelLink>
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>

<script>
import EditPannel from "@/components/EditPannel.vue";
import OptionMenu from "@/components/OptionMenu.vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";
import * as firebase from "@/vendor/firebase";
import * as database from "@/vendor/database";
import * as utils from "@/utils/utils";
import { mapState } from "vuex";
import PanelDocument from "@/components/client/clientDocument/PanelDocument.vue";
import PanelLink from "@/components/client/clientDocument/PanelLink.vue";
import GridActions from "@/components/client/clientDocument/GridActions.vue";
import GridDropdownMenu from "@/components/client/clientDocument/GridDropdownMenu";

export default {
  props: ["editOpenTitle"],
  data() {
    return {
      queryId: null,
      filterTxt: "",
      gridOptions: {},
      columnDefs: null,
      beforeRowData: [],
      rowData: [],
      editOpen: false,
      submitLoading: false,
      linkSubmitLoading: false,
      dd: {
        index: null,
        el: null,
        isOpen: false,
      },
    };
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    beforeRowData: function () {
      this.rowData = [];
      this.beforeRowData.forEach((item, index) => {
        this.rowData.push({ rowindex: index, ...item });
      });
    },
  },
  computed: {
    ...mapState(["user"]),
  },
  components: {
    EditPannel,
    OptionMenu,
    AgGridVue,
    PanelDocument,
    PanelLink,
    GridActions,
    GridDropdownMenu,
  },
  beforeMount() {
    this.queryId = this.$route.query.id;
    this.createColumnDefs();
    this.createRowData();
  },
  created: function () {
    this.$EventBus.$on("globalClick", (event) => {
      this.hideAgDropdown(event);
    });
    setTimeout(() => {
      this.enableSetLocal = true;
    }, 3000);
  },
  methods: {
    refreshRowData: function () {
      this.gridOptions.api.setRowData(this.rowData);
    },
    onQuickFilterChanged: function (event) {
      this.filterTxt = event.target.value;
      this.gridOptions.api.setQuickFilter(event.target.value);
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    createColumnDefs: function () {
      this.gridOptions = {
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        sideBar: false,
        enableCellTextSelection: true,
        pagination: true,
        paginationPageSize: 9,
        paginationNumberFormatter: function (params) {
          return "[" + params.value.toLocaleString() + "]";
        },
      };
      this.columnDefs = [
        { headerName: "NAME", field: "name", width: 500 },
        {
          headerName: "ACTIONS",
          field: "link",
          cellClass: "overflow-visible",
          cellRendererFramework: "GridDropdownMenu",
          sortable: false,
          filter: false,
          rowGroup: false,
        },
      ];
    },
    createRowData: function () {
      if (this.queryId) {
        this.beforeRowData = [];
        firebase.storage
          .ref()
          .child("clients/" + this.queryId)
          .listAll()
          .then((result) => {
            result.items.forEach(async (item) => {
              const linkResult = await firebase.storageGetDownloadUrl(
                item.fullPath
              );
              const link = linkResult.ok ? linkResult.data : null;
              this.beforeRowData.push({
                name: item.name,
                fullPath: item.fullPath,
                link: link,
                ddOpen: false,
              });
            });
          });
        database
          .getAllDocDataQuery("company_doc_links", "owner", this.queryId)
          .then((result) => {
            if (result.ok) {
              const resultData = result.data;
              for (const i in resultData) {
                this.beforeRowData.push({
                  name: resultData[i].data.name
                    ? resultData[i].data.name
                    : resultData[i].data.link,
                  link: resultData[i].data.link,
                  id: resultData[i].id,
                  type: "link",
                  ddOpen: false,
                });
              }
            }
          });
      }
    },
    // edit pannel: control open which component
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
    addFile: function () {
      this.openEditPannel(1, "Add File", true);
    },
    addLink: function () {
      this.openEditPannel(2, "Add Link", true);
    },
    panelButtonClick: async function (files) {
      if (files && this.queryId) {
        let count = 0;
        this.submitLoading = true;
        for (const i in files) {
          const file = files[i].file;
          if (file) {
            count++;
            const fileName = file.name;
            const result = await firebase.storagePut(
              `clients/${this.queryId}/`,
              fileName,
              file
            );
            if (result.ok) {
              this.$toasted.global.toast_success({
                message: `save ${fileName} success`,
              });
            } else {
              this.$toasted.global.toast_error({
                message: `save ${fileName} error`,
              });
            }
          }
        }
        if (count == 0) {
          this.$toasted.global.toast_error({ message: "no file to save" });
        } else {
          this.createRowData();
        }
        this.closeEditPannel();
        this.submitLoading = false;
      } else {
        this.$toasted.global.toast_error({ message: "save error" });
      }
    },
    panelLinkButtonClick: function (name, link) {
      if (this.queryId) {
        this.linkSubmitLoading = true;
        const data = {
          owner: this.queryId,
          name,
          link,
        };
        database
          .addDoc("company_doc_links", data)
          .then((result) => {
            if (result.ok) {
              this.$toasted.global.toast_success({ message: "save success" });
              this.createRowData();
            } else {
              this.$toasted.global.toast_error({ message: "save error" });
            }
          })
          .finally(() => {
            this.closeEditPannel();
            this.linkSubmitLoading = false;
          });
      }
    },
    downloadFile: function (data) {
      window.open(data.link, "_blank");
    },
    deleteFile: function (data) {
      utils.deleteConfirm(() => {
        if (data.type == "link") {
          database.deleteDoc("company_doc_links", data.id).then((response) => {
            if (response.ok) {
              this.$toasted.global.toast_success({ message: "delete success" });
              this.createRowData();
            } else {
              this.$toasted.global.toast_error({ message: "delete error" });
            }
          });
        } else {
          firebase.storageDelete(data.fullPath).then((response) => {
            if (response.ok) {
              this.$toasted.global.toast_success({ message: "delete success" });
              this.createRowData();
            } else {
              this.$toasted.global.toast_error({ message: "delete error" });
            }
          });
        }
      });
    },
    openCurrentAgDropdown: function (item, el) {
      if (this.dd.isOpen) {
        this.$set(this.rowData[this.dd.index], "ddOpen", false);
      }
      this.dd.isOpen = item.ddOpen;
      this.dd.index = item.rowindex;
      this.dd.el = el;
    },
    hideAgDropdown: function (e) {
      if (this.dd.el && !this.dd.el.contains(e.target)) {
        this.hideCurrentAgDropdown();
      }
    },
    hideCurrentAgDropdown: function () {
      this.$set(this.rowData[this.dd.index], "ddOpen", false);
      this.dd.isOpen = false;
    },
  },
};
</script>
